import React, { Component } from "react";
import { withRouter } from "react-router";
import ChatSupportBtn from "./ChatSupportBtn";
import { logout } from "./Utility";
import customFetch from "./apicall/api";
import { PEButton, PEDiv, PEImg, PEInput } from "./permissionComponents";
import {
  navtime,
  chkapiinput,
  checkBanner,
  bannertimer,
  generateId,
} from "./Utility";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch_unit_level_id: "",
      parent_entity_name: "",
      max_unit_level_id: "",
      entity_name: "",
      effective_designation_id: "",
      showPasswordUpdateModal: false,
      npass: "",
      cpass: "",
      isViewpass: true,
      isViewpass1: true,
      passerr: "",
      SuccessOpen: false,
      isErrOpen: false,
      api_error_message: "",
      isSpin: false
    };
  }
  componentDidMount() {
    document.title = "Dashboard";
    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      localStorage.clear();
      this.props.history.push("/");
    }
    const {
      api_token,
      branch_unit_level_id,
      parent_entity_name,
      max_unit_level_id,
      effective_designation_id,
      is_first_login,
      password_update_flag,
      password_age
    } = (this.props.location && this.props.location.state) || {};
    localStorage.setItem("api_token", api_token);

    this.setState({
      branch_unit_level_id: branch_unit_level_id,
      parent_entity_name: parent_entity_name,
      max_unit_level_id: max_unit_level_id,
      effective_designation_id: effective_designation_id,
      showPasswordUpdateModal: is_first_login === "1" || password_update_flag === true || password_age > 90
    });
  }

  viewpass = (type) => {
    if (type === 1) {
      this.setState({ isViewpass: !this.state.isViewpass });
    } else {
      this.setState({ isViewpass1: !this.state.isViewpass1 });
    }
  };

  comparepass = (e) => {
    const cpass = e.target.value;
    if (this.state.npass !== cpass) {
      this.setState({ cpass, passerr: "Passwords do not match" });
    } else {
      this.setState({ cpass, passerr: "" });
    }
  };

  handlemailSubmitpass = async (event) => {
    event.preventDefault();
    const { api_token } = (this.props.location && this.props.location.state) || {};
    const uid = localStorage.getItem("in_userid");

    if (this.state.passerr) return;
    if (!this.state.npass || !this.state.cpass) {
      this.setState({ 
        isErrOpen: true, 
        api_error_message: "Please fill all fields" 
      });
      return;
    }

    this.setState({ isSpin: true });
    try {
    const formdata = new FormData();
    formdata.append("userid", uid);
    formdata.append("user_password", this.state.npass);

      const response = await customFetch(process.env.REACT_APP_URL + "/changepassword", {
        method: "POST",
        headers: {
          "api-token": api_token,
          component_id: generateId(10),
          apiId: generateId(10),
          api_group_id: "",
          component: "Dashboard",
          user_id: uid,
        },
        body: formdata,
      });
      if (response.headers.get("api_code") > 0) {
        throw new Error(response.headers.get("api_error_message"));
      }
      const json = await response.json();
      if ([3, 4, 5].includes(json.api_code)) {
        localStorage.clear();
        this.props.history.push("/");
        return;
      }
      if (json.isupdate) {
        this.setState({
          SuccessOpen: true,
          api_error_message: json.message || "Password updated successfully!",
          isSpin: false,
          showPasswordUpdateModal: false
        });
      } else {
        throw new Error(json.message || "Password update failed");
      }
    } catch (error) {
      this.setState({
        isErrOpen: true,
        api_error_message: error.message || "An error occurred",
        isSpin: false
      });
    }
  };

  render() {
    const { effective_designation_id } = this.state;
    const { api_token } = (this.props.location && this.props.location.state) || {};

    return (
      <>
        {(this.state.showPasswordUpdateModal || this.state.SuccessOpen || this.state.isErrOpen) && (
          <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
        )}

        {/* Password Update Modal */}
        {this.state.showPasswordUpdateModal && (
          <div className="password-modal">
            <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Change Password</h5>
                    {!((this.props.location.state && 
                        (this.props.location.state.is_first_login === "1" || 
                        this.props.location.state.password_update_flag === true))) && (
                      <button
                        type="button"
                        className="close"
                        onClick={() => this.setState({ showPasswordUpdateModal: false })}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    )}
                  </div>
                  <div className="modal-body">
                    <form onSubmit={this.handlemailSubmitpass}>
                      <div className="form-group">
                        <label htmlFor="newPassword">New Password</label>
                        <div className="input-with-icon">
                          <input
                            type={this.state.isViewpass ? "password" : "text"}
                            id="newPassword"
                            name="npass"
                            placeholder="Enter Password"
                            className="form-control"
                            value={this.state.npass}
                            onChange={(e) => this.setState({ npass: e.target.value })}
                          />
                          <span 
                            className="password-toggle-icon"
                            onClick={() => this.viewpass(1)}
                          >
                            <img
                              src={require("../assets/images/view.png")}
                              alt="Toggle password visibility"
                            />
                          </span>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <div className="input-with-icon">
                          <input
                            type={this.state.isViewpass1 ? "password" : "text"}
                            id="confirmPassword"
                            name="cpass"
                            placeholder="Confirm Password"
                            className="form-control"
                            onChange={this.comparepass}
                          />
                          <span 
                            className="password-toggle-icon"
                            onClick={() => this.viewpass(2)}
                          >
                            <img
                              src={require("../assets/images/view.png")}
                              alt="Toggle password visibility"
                            />
                          </span>
                        </div>
                        {this.state.passerr && (
                          <div className="invalid-feedback d-block">
                            {this.state.passerr}
                          </div>
                        )}
                      </div>
                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          disabled={this.state.isSpin}
                        >
                          {this.state.isSpin ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                              Updating...
                            </>
                          ) : (
                            "Update"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.SuccessOpen && (
          <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content cdb-confirm-box-msg success-popup">
                <div className="modal-header">
                  <h5 className="modal-title">Success</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => {
                      this.setState({ SuccessOpen: false });
                      logout();
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="popup-message">{this.state.api_error_message}</p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      this.setState({ SuccessOpen: false });
                      logout();
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.isErrOpen && (
          <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content cdb-confirm-box-msg error-popup">
                <div className="modal-header">
                  <h5 className="modal-title">Error</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.setState({ isErrOpen: false })}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="popup-message">{this.state.api_error_message}</p>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={() => this.setState({ isErrOpen: false })}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <section className="main-sec">
          <div className="container fix-width">
            <div className="logo-area">
              <PEDiv element_id="ProfileBtn" className="user_icon">
                <img
                  src={require("../assets/images/Profile.svg")}
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/Profile",
                      state: {
                        api_token: api_token,
                      },
                    });
                  }}
                  alt=""
                />
              </PEDiv>
              <img src={require("../assets/images/aceN Logo.png")} alt="" />
              <div className="log-out1">
                <img
                  src={require("../assets/images/power-off.png")}
                  onClick={() => logout()}
                  alt=""
                />
              </div>
            </div>
            <div className="dashboard-card-holder">
              <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  this.props.history.push({
                    pathname: "/TO_slip",
                    state: {
                      api_token: api_token,
                      effective_designation_id: effective_designation_id,
                    },
                  });
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>Fin Ops</h2>
                  </div>
                  {/* <div className="card-subheading">
                    <h2>Check your transaction history.<br/>You can find a list of your transactions</h2>
                  </div> */}
                  <div className="text-center"></div>
                </div>
              </div>
              {/* <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  this.props.history.push({
                    pathname: "/supportticketlist",
                    state: {
                      api_token: api_token,
                      effective_designation_id: effective_designation_id,
                    },
                  });
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>Support Ticket</h2>
                  </div>
                  <div className="text-center"></div>
                </div>
              </div> */}
              <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  this.props.history.push({
                    pathname: "/Transaction_history",
                    state: {
                      api_token: api_token,
                      effective_designation_id: effective_designation_id,
                    },
                  });
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>History</h2>
                  </div>
                  {/* <div className="card-subheading">
                    <h2>Check your transaction history.<br/>You can find a list of your transactions</h2>
                  </div> */}
                  <div className="text-center"></div>
                </div>
              </div>

              <div
                className={
                  effective_designation_id === ""
                    ? "card card-border-small col-sm-6 py-2 disabletile"
                    : "card card-border-small col-sm-6 py-2"
                }
                onClick={() => {
                  // this.props.history.push({
                  //   pathname: "/Transaction_history",
                  //   state: {
                  //     api_token: api_token,
                  //     effective_designation_id: effective_designation_id,
                  //   },
                  // });
                  console.log(
                    "REACT_APP_PAYLOAD_VIEW",
                    process.env.REACT_APP_PAYLOAD_VIEW
                  );
                  window.location.assign(
                    process.env.REACT_APP_PAYLOAD_VIEW +
                      "/payload?api_token=" +
                      api_token +
                      "&desc_id=" +
                      effective_designation_id+
                      "&d_id=" +
                      localStorage.getItem("department_id")+
                      "&b_id=" +
                      localStorage.getItem("branch_id")+
                      "&uid=" +
                      localStorage.getItem("in_userid")
                  );
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>
                      Payload
                      {effective_designation_id == "" && (
                        <div className="nb-spinner t10-r10-25"></div>
                      )}
                    </h2>
                  </div>
                  {/* <div className="card-subheading">
                    <h2>Check your transaction history.<br/>You can find a list of your transactions</h2>
                  </div> */}
                  <div className="text-center"></div>
                </div>
              </div>
              <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  this.props.history.push({
                    pathname: "/upi_autopay",
                    state: {
                      api_token: api_token,
                      effective_designation_id: effective_designation_id,
                    },
                  });
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>UPI Autopay</h2>
                  </div>
                  <div className="text-center"></div>
                </div>
              </div>
              <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  window.location.assign(
                    process.env.REACT_APP_PAYLOAD_VIEW +
                      "/Esign?api_token=" +
                      api_token +
                      "&desc_id=" +
                      effective_designation_id +
                      "&uid=" +
                      localStorage.getItem("in_userid")+
                      "&d_id=" +
                      localStorage.getItem("department_id")+
                      "&b_id=" +
                      localStorage.getItem("branch_id")
                  );
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>E-sign</h2>
                  </div>
                  <div className="text-center"></div>
                </div>
              </div>
              <div
                className="card card-border-small col-sm-6 py-2"
                onClick={() => {
                  this.props.history.push({
                    pathname: "/kyc_activities",
                    state: {
                      api_token: api_token,
                      effective_designation_id: effective_designation_id,
                    },
                  });
                }}
              >
                <div className="card-body">
                  <div className="image-holder-4">
                    <img
                      src={require("../assets/images/check-list.png")}
                      alt=""
                    />
                  </div>
                  <div className="card-heading">
                    <h2>KYC Activities</h2>
                  </div>
                  <div className="text-center"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ChatSupportBtn history={this.props.history} />
      </>
    );
  }
}

export default withRouter(Dashboard);
